import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "postToc", "tocToggleBtn" ]

  connect() {
  }

  toggleToc() {
    const element = this.postTocTarget;
    const toggleBtn = this.tocToggleBtnTarget;

    element.classList.toggle('hidden');

    if(element.classList.contains('hidden')) {
      toggleBtn.innerText = 'show';
    } else {
      toggleBtn.innerText = 'hide';
    }
  }
}
